export default __webpack_public_path__ + "static/media/add-icon-white-filled.878c751e.svg";